import { Reveal } from "./Reveal";

export const Section = ({ id, children, className = "" }) => (
    <section id={id} className={`relative px-6 py-24 md:py-32 ${className}`}>
        {children}
    </section>
);

export const Column = ({ children, className = "" }) => (
    <div className={`mx-auto w-full max-w-[68ch] ${className}`}>{children}</div>
);

export const Eyebrow = ({ children }) => (
    <Reveal as="p" className="mx-auto mb-6 max-w-[68ch] font-sans text-xs font-medium tracking-[0.28em] uppercase text-sepia">
        {children}
    </Reveal>
);

export const Heading = ({ children }) => (
    <Reveal as="h2" className="mx-auto mb-12 max-w-[68ch] font-serif text-4xl leading-[1.08] tracking-tight text-ink sm:text-5xl">
        {children}
    </Reveal>
);

export const P = ({ children, delay = 0 }) => (
    <Reveal as="p" delay={delay} className="mx-auto mb-7 max-w-[68ch] font-serif text-[1.18rem] leading-[1.8] text-ink/90 md:text-[1.3rem]">
        {children}
    </Reveal>
);

export const Statement = ({ children }) => (
    <Reveal as="p" className="mx-auto my-10 max-w-[68ch] font-serif text-3xl italic leading-snug text-ink md:text-4xl">
        {children}
    </Reveal>
);

export const PullQuote = ({ children }) => (
    <Reveal className="my-16 md:my-24">
        <div className="mx-auto max-w-[44rem] text-center">
            <span className="mx-auto mb-6 block h-1.5 w-1.5 rounded-full bg-wax" />
            <p className="font-serif text-2xl italic leading-[1.4] text-ink sm:text-3xl md:text-[2.6rem] md:leading-[1.35]">
                {children}
            </p>
        </div>
    </Reveal>
);

export const Aside = ({ children }) => (
    <Reveal className="mx-auto mt-14 max-w-[46rem]">
        <p className="border-t border-rule pt-8 font-sans text-sm leading-relaxed tracking-wide text-sepia">
            {children}
        </p>
    </Reveal>
);
